<template>
  <div id="content" :class="{'bg-white': isWhitePage, 'max-width': !isCoachingPlatform}">
    <transition name="fade" mode="out-in">
      <component @scroll-to="scrollTo" :is="currentContent" />
    </transition>
  </div>
</template>

<script>

import Dmh from "@/pages/Dmh.vue"
import DmhStart from "@/pages/DmhStart.vue"
import DmhFaqs from "../pages/DmhFaqs.vue";
import DmhArticles from "../pages/DmhArticles.vue";
import DmhFinance from "../pages/DmhFinance.vue";
import DmhF2F from "../pages/DmhF2F.vue";
import DmhMessage from "../pages/DmhMessage.vue";
import MyHealth from "../pages/MyHealth.vue";
import MyHealthArea from "../pages/MyHealthArea.vue";
import MyHealthHandover from "../pages/MyHealthHandover.vue";
import PaymentConfirmation from "../pages/PaymentConfirmation.vue";
import DmhTransactionCancelled from "../pages/DmhTransactionCancelled.vue";
import CoachingPlatform from "./TMH/CoachingPlatform.vue";
import BookingVideoRoom from "./TMH/VideoRoomWithCoach/BookingVideoRoom.vue";


const mappings = {
  home: Dmh,
  dmh: Dmh,
  dmhStart: DmhStart,
  paymentConfirmation: PaymentConfirmation,
  dmhTransactionCancelled: DmhTransactionCancelled,
  dmhFinance: DmhFinance,
  dmhFaqs: DmhFaqs,
  dmhArticles: DmhArticles,
  dmhF2F: DmhF2F,
  dmhMessage: DmhMessage,
  myHealth: MyHealth,
  myHealthArea: MyHealthArea,
  myHealthHandover: MyHealthHandover,
  coachingPlatform: CoachingPlatform,
  bookingVideoRoom: BookingVideoRoom,
};
// the mappings below will overwrite the above mapping where NavigationV2 is being used as the nav


export default {
  name: "ContentRouter",
  methods: {
    scrollTo(coordinates) {
      this.$emit("scroll-to", coordinates);
    },
  },
  computed: {
    navType() {
      return this.$store.getters.navType;
    },
    currentContent() {
      return mappings[this.$route.name];
    },
    isWhitePage(){
      let whitePages = ['dmh', 'dmhStart', 'dmhFaqs', 'dmhArticles','dmhFinance', 'dmhF2F', 'dmhMessage'];
      return whitePages.includes(this.$route.name)
    },
    isCoachingPlatform() {
      return this.$route.name === 'coachingPlatform'
    }
  },
};
</script>
<style lang="less">
#content {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  & > div {
    width: 100%;
  }

  &.max-width {
    width: 100%;
    max-width: 1170px;
    margin: 0 auto;
  }
}
.fade-enter-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease-in;
}
.fade-leave-active {
  transition-duration: 0s;
  transition-property: opacity;
  transition-timing-function: ease-in;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0s ease;
}
.slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
</style>
